import React, { useState } from 'react';
import '../styles/ContactForm.css';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    serviceType: 'residential',
    cleaningType: 'standard',
    propertySize: 'small',
    message: '',
    preferredContact: 'email',
    preferredTime: 'morning'
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
  };

  return (
    <div className="contact-page">
      <section className="contact-hero">
        <div className="contact-hero-content">
          <h1>Get in Touch</h1>
          <p>Ready for a spotless space? Fill out the form below and we'll get back to you within 24 hours.</p>
        </div>
      </section>

      <div className="contact-form-container">
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-grid">
            <div className="form-group">
              <label htmlFor="firstName">First Name*</label>
              <input
                type="text"
                id="firstName"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="lastName">Last Name*</label>
              <input
                type="text"
                id="lastName"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address*</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="phone">Phone Number*</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="serviceType">Service Type*</label>
              <select
                id="serviceType"
                name="serviceType"
                value={formData.serviceType}
                onChange={handleChange}
                required
              >
                <option value="residential">Residential Cleaning</option>
                <option value="commercial">Commercial Cleaning</option>
                <option value="movein">Move In/Out Cleaning</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="cleaningType">Cleaning Type*</label>
              <select
                id="cleaningType"
                name="cleaningType"
                value={formData.cleaningType}
                onChange={handleChange}
                required
              >
                <option value="standard">Standard Cleaning</option>
                <option value="deep">Deep Cleaning</option>
                <option value="custom">Custom Package</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="propertySize">Property Size*</label>
              <select
                id="propertySize"
                name="propertySize"
                value={formData.propertySize}
                onChange={handleChange}
                required
              >
                <option value="small">Small (Under 1,000 sq ft)</option>
                <option value="medium">Medium (1,000-2,000 sq ft)</option>
                <option value="large">Large (2,000-3,000 sq ft)</option>
                <option value="xlarge">Extra Large (3,000+ sq ft)</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="preferredContact">Preferred Contact Method*</label>
              <select
                id="preferredContact"
                name="preferredContact"
                value={formData.preferredContact}
                onChange={handleChange}
                required
              >
                <option value="email">Email</option>
                <option value="phone">Phone</option>
                <option value="text">Text Message</option>
              </select>
            </div>

            <div className="form-group full-width">
              <label htmlFor="preferredTime">Best Time to Contact*</label>
              <select
                id="preferredTime"
                name="preferredTime"
                value={formData.preferredTime}
                onChange={handleChange}
                required
              >
                <option value="morning">Morning (8AM - 12PM)</option>
                <option value="afternoon">Afternoon (12PM - 4PM)</option>
                <option value="evening">Evening (4PM - 8PM)</option>
              </select>
            </div>

            <div className="form-group full-width">
              <label htmlFor="message">Additional Details</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Tell us about any specific cleaning needs or special instructions..."
                rows="4"
              />
            </div>
          </div>

          <button type="submit" className="submit-button">
            Get Your Quote
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactForm; 